import { createHttpActions } from '@next/arable-lib/shared';

import { OrganicMatterBenchmark, OrganicMatterReport } from '../organic-matter-balance.models';

export const [
  loadOrganicMatterBalance,
  loadOrganicMatterBalanceSuccess,
  loadOrganicMatterBalanceFailed,
] = createHttpActions<
  { cropYear: number },
  { report: OrganicMatterReport },
  { message: string }
>('Load Organic Matter Balance');

export const [
  loadOrganicMatterBenchmark,
  loadOrganicMatterBenchmarkSuccess,
  loadOrganicMatterBenchmarkFailed,
] = createHttpActions<
  { cropYear: number },
  { benchmark: OrganicMatterBenchmark },
  { message: string }
>('Load Organic Matter Benchmark');
